import { useEffect, useCallback } from "react"

function useKey(key, callback) {
	const callbackMemoized = useCallback(callback, [key, callback])

	useEffect(() => {
		const keydownHandler = (event) => {
			if (event.key === key) {
				callbackMemoized()
			}
		}

		window.addEventListener("keydown", keydownHandler)

		return () => {
			window.removeEventListener("keydown", keydownHandler)
		}
	}, [key, callbackMemoized])
}

export default useKey
